import {get} from '../../../components/api';
import {courseType} from '../../../constants/url';

function getCourseType(role: string, token: string) {
  const url = `${courseType}?role=${role}`;
  return get(url, token);
}

export default getCourseType;
